// extracted by mini-css-extract-plugin
export var falconContainer = "_vt-2";
export var offerCenter = "_vt-0";
export var roktContainer = "_vt-1";